import { createSelector } from 'reselect';

const menu = state => state.application.menu;
const flash = state => state.application.flash;

export const selectMenuOpenSelector = createSelector(menu, m => m.selectOpen);
export const menuOpenSelector = createSelector(menu, m => m.open);
export const flashMessageSelector = createSelector(flash, f => f.message);
export const flashOpenSelector = createSelector(flash, f => f.open);
export const flashTypeSelector = createSelector(flash, f => f.type);



// WEBPACK FOOTER //
// ./src/selectors/application.js